import {
  CheckCircleIcon,
  QuestionMarkCircleIcon,
  XCircleIcon,
} from "@heroicons/react/24/outline";
import classNames from "classnames";
import CiroTooltipContainer from "../shared/CiroTooltipContainer";
import { CiroTableCellAlignEnum } from "../shared/CiroTable/CiroTableCell";
import CiroTableCell from "../shared/CiroTable/CiroTableCell";
import { useContext } from "react";
import NavigationContext from "../../contexts/NavigationContext";

const AutopilotScoringResultTableCell = ({
  result,
  isLast,
  changeBreakpointOnNavCollapse = true,
}: {
  result?: {
    criterion_fit?: boolean | null;
    reasoning?: string | null;
  };
  isLast: boolean;
  changeBreakpointOnNavCollapse?: boolean;
}) => {
  const { isNavCollapsed } = useContext(NavigationContext);
  const breakpointClass = changeBreakpointOnNavCollapse && !isNavCollapsed ? "max-2xl:hidden" : "max-xl:hidden";
 
  return (
    <CiroTableCell
      align={CiroTableCellAlignEnum.CENTER}
      isLastRow={isLast}
      className={classNames(
        breakpointClass,
      )}
    >
      <CiroTooltipContainer tooltip={result?.reasoning}>
        <div className={classNames("flex", "items-center", "justify-center")}>
          {result?.criterion_fit && (
            <CheckCircleIcon
              className={classNames("w-6", "h-6", "text-orange-400")}
            />
          )}
          {result?.criterion_fit === false && (
            <XCircleIcon
              className={classNames("w-6", "h-6", "text-gray-400")}
            />
          )}
          {result?.criterion_fit !== true &&
            result?.criterion_fit !== false && (
              <QuestionMarkCircleIcon
                className={classNames("w-6", "h-6", "text-orange-400")}
              />
            )}
        </div>
      </CiroTooltipContainer>
    </CiroTableCell>
  );
};

export default AutopilotScoringResultTableCell;
